module.exports = __webpack_public_path__ + "media/images/pic/gallery/2019/impreza-bonenkai-aa0576a3e06ce832ffe8d1951cda6668.jpg";